import { render } from "./InternetPointsTable.vue?vue&type=template&id=d609f9ce&scoped=true"
import script from "./InternetPointsTable.vue?vue&type=script&lang=js"
export * from "./InternetPointsTable.vue?vue&type=script&lang=js"

import "./InternetPointsTable.vue?vue&type=style&index=0&id=d609f9ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d609f9ce"]])

export default __exports__